import { FC } from 'react';
import PropTypes from 'prop-types';
import { CustomerGetResponse, CustomerUser } from 'src/interfaces/user/customer';
import { CustomerAddress } from 'src/interfaces/new-channel-partner/channelPartner';
import { GetUserProductResponse } from 'src/interfaces/userProduct/user-product';
import { UserProductsListCard } from '../../../common/userProductsListCard';
import { AddressCard } from './addressCard';
import { CustomerProfileCard } from './userProfileCard';

interface ProfileDetailsCardProps {
  userDetails: CustomerGetResponse;
  productsList: GetUserProductResponse[];
  enableRaiseRequest: boolean;
  addEditCustomerProfile?: (data: CustomerUser, isAdd: boolean) => Promise<boolean>;
  setAddress?: (data: CustomerAddress) => void;
  addAddress?: (data: CustomerAddress) => Promise<boolean>;
  updateProductState?: () => void;
  setProduct?: (data: GetUserProductResponse) => void;
}

export const ProfileDetailsCard: FC<ProfileDetailsCardProps> = (props) => {
  const { userDetails, addEditCustomerProfile, setAddress,
    addAddress, setProduct, updateProductState, productsList,
    enableRaiseRequest } = props;

  return (
    <>
      <CustomerProfileCard
        customerDetail={userDetails}
        addEditCustomerProfile={addEditCustomerProfile}
        enableRaiseRequest={enableRaiseRequest}
      />
      <AddressCard
        addresses={userDetails?.addresses}
        setAddress={setAddress}
        addAddress={addAddress}
        enableRaiseRequest={enableRaiseRequest}
      />
      <UserProductsListCard
        userId={userDetails?.username}
        productsList={productsList}
        updateProductState={updateProductState}
        setProduct={setProduct}
        enableRaiseRequest={enableRaiseRequest}
      />
    </>
  );
};

ProfileDetailsCard.propTypes = {
  // @ts-ignore
  userDetails: PropTypes.object,
  enableRaiseRequest: PropTypes.bool,
  updateProductState: PropTypes.func,
  productsList: PropTypes.array,
  addEditCustomerProfile: PropTypes.func,
  setAddress: PropTypes.func,
  addAddress: PropTypes.func,
  setProduct: PropTypes.func,
};
